module.exports = __webpack_public_path__ + "static/media/tree-step-6_3.092ca612.svg";